import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import SQChecklistListView from 'src/components/StartUp/sqChecklist/SQChecklistListView';
import SQChecklistPage from 'src/components/StartUp/sqChecklist/SQChecklistPage';

const initialState: any = {
  showCMPArr: [
    {
      cmp: SQChecklistListView,
      key: 'sqchecklistview',
      curruntlyActive: true
    },
    {
      cmp: SQChecklistPage,
      key: 'sqchecklistpage',
      curruntlyActive: false
    }
  ],
  selectedRowData: {}
};

export const sqCheckList = createSlice({
  name: 'sqCheckList',
  initialState,
  reducers: {
    setChckListCMPArr: (state: any, action: PayloadAction<string>) => {
      const tempBackArr = state.showCMPArr.map((ele: any) => {
        if (ele.key === action.payload) {
          return { ...ele, curruntlyActive: true };
        }
        return { ...ele, curruntlyActive: false };
      });
      state.showCMPArr = tempBackArr;
    },
    setSelectedRowData: (state: any, action: any) => {
      state.selectedRowData = action.payload;
    }
  }
});

export const { setChckListCMPArr, setSelectedRowData } = sqCheckList.actions;
